import Card from "../ui/Card";
import classes from "./MeetupItem.module.css";
import { useContext, useState } from "react";
import FavoritesContext from "../../../store/favorites-context";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { AuthContext } from "../../../store/auth-context";
import { useNavigate } from "react-router-dom";

function MeetupItem(props) {
	const navigate = useNavigate();
	//state for showing city modals
	const [showModal, setShowMOdal] = useState(false);

	// state for showing signUp Modal prompt
	const [signUp, setSignUp] = useState(false);
	const signUpPromptModal = () => setSignUp(true);

	//navigate to signUp page
	const navigateToSignUp = () => {
		navigate("/signup")
	};

	// check if user is authenticated
	const { user } = useContext(AuthContext);

	const displayModal = () => setShowMOdal(true);

	const favoritesCtx = useContext(FavoritesContext);
	const itemIsFavorite = favoritesCtx.itemIsFavorite(props.id);
	function toggleFavoriteStatusHandler() {
		if (itemIsFavorite) {
			favoritesCtx.removeFavorite(props.id);
		} else {
			if (!user) {
				signUpPromptModal();
			}
			favoritesCtx.addFavorite(props.id);
		}
	}

	
	return (
		<>
			<li className={classes.item}>
				<Card title="Click on image to expand">
					<div className={classes.image} onClick={displayModal}>
						<img src={props.image} alt={props.title} />
					</div>
					<div className={classes.content}>
						<div>
							<h3>{props.title}</h3>
						</div>

						<address style={{ fontStyle: "italic" }}>
							{props.address}
						</address>
						<div className={classes.description}>
							<p
								style={{
									fontFamily: "sans-serif",
								}}
							>
								{props.description}
							</p>
						</div>
					</div>
					<div className={classes.actions}>
						<button
							onClick={toggleFavoriteStatusHandler}
							className={classes.actionsBtn}
						>
							{itemIsFavorite
								? "Remove from Favorites"
								: "To Favorites"}
						</button>
						<ToastContainer />
					</div>
				</Card>
			</li>

			{/* Modal for displaying city info!*/}
			<Modal
				show={showModal}
				onHide={() => setShowMOdal(false)}
				size="lg"
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title>{props.title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div
						style={{
							display: "flex",
							flexWrap: "wrap",
							justifyContent: "center",
						}}
					>
						<div>
							<img
								src={props.image}
								alt={props.title}
								style={{
									borderRadius: "8px",
									width: "80%",
									marginLeft: "10%",
								}}
								width={700}
							/>
						</div>
						<div style={{ marginTop: "1rem", fontWeight: "500" }}>
							{props.address}
						</div>
						<div style={{ marginTop: "1rem" }}>
							{props.description}
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={() => setShowMOdal(false)}>Close</Button>
				</Modal.Footer>
			</Modal>

			{/* Modal for asking user to signUp*/}
			<Modal
				show={signUp}
				onHide={() => setSignUp(false)}
				size="md"
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title>Sign Up</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					Please Sign Up to be able to add vacation destinations to
					your favorites list.
				</Modal.Body>
				<Modal.Footer>
					<Button variant="danger" onClick={() => setSignUp(false)}>
						Close
					</Button>
					<Button variant="success" onClick={navigateToSignUp}>Sign Up</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
}

export default MeetupItem;
